export default __webpack_public_path__ + "static/media/CDKGlobalWM_BLK.b993ed04.jpg";